import { render, staticRenderFns } from "./GlBackdrop.vue?vue&type=template&id=68a74dac&scoped=true&"
import script from "./GlBackdrop.vue?vue&type=script&lang=js&"
export * from "./GlBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./GlBackdrop.vue?vue&type=style&index=0&id=68a74dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a74dac",
  null
  
)

export default component.exports